module.exports = __webpack_public_path__ + "static/img/piebg-3d.aa11286.png";


//////////////////
// WEBPACK FOOTER
// ./static/indexEditorIcon/piebg-3d.png
// module id = 3/y2
// module chunks = 3